<template>
  <el-input class="fuzzy-search" placeholder="Fuzzy Search" size="mini" :value="query" @input="search($event)" prefix-icon="el-icon-search">
    <i slot="suffix" class="el-input__icon el-icon-circle-close is-clickable" @click="clear"></i>
  </el-input>
</template>
<style>
.fuzzy-search.el-input {
  width: auto;
}
</style>

<script>
import debounce from 'lodash/debounce'
import Fuse from 'fuse.js'
import { mapState } from 'vuex'
import { createSearch, SET_QUERY, SET_IDS } from '../store/modules/fuzzy-search'

const createFuse = (items, properties) => new Fuse(items, {
  // distance: 0,
  threshold: 0.3,
  keys: properties,
  id: 'id'
})

export default {
  props: [
    'collectionName',
    'properties'
  ],

  data () {
    return {
      fuse: null,
      query: ''
    }
  },

  created () {
    if (!this.$store.state[this.collectionName]['search']) {
      this.$store.registerModule([this.collectionName, 'search'], createSearch())
    }
    this.query = this.initialQuery
    this.search(this.query || '')
    if (this.all.length !== 0) {
      this.fuse = createFuse(this.all, this.properties)
    }
  },

  destroyed () {
    // this.$store.unregisterModule([this.collectionName, 'search'])
  },

  computed: {
    ...mapState({
      initialQuery (state) {
        return state[this.collectionName]['search']['query']
      },
      allIds (state) {
        return state[this.collectionName].ids
      },
      all (state) {
        const localState = state[this.collectionName]
        return localState.ids.map(id => localState.entities[id])
      }
    })
  },

  watch: {
    allIds: function () {
      this.fuse = createFuse(this.all, this.properties)
      this.search('')
    }
  },

  methods: {
    search: function (value) {
      this.query = value
      this.fuseSearch(value)
    },

    fuseSearch: debounce(function (value) {
      this.$store.commit(this.collectionName + '/search/' + SET_QUERY, value)
      let foundIds = this.fuse && this.fuse.search(value)
      if (foundIds) {
        // if search field is cleared display all available items
        if (value.trim().length === 0 && foundIds.length === 0) {
          foundIds = [...this.allIds]
        }
        this.$store.commit(this.collectionName + '/search/' + SET_IDS, foundIds)
      }
    }, 350),

    clear () {
      this.search('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FuzzySearch.vue